import styled from '@emotion/styled';

export const DatePickerWrapper = styled.div`
  width: 100%;
  min-height: 250px;
`;

export const ModalDatePickerWrapper = styled.div`
  width: 100%;
`;



